import React from 'react';
import PropTypes from 'prop-types';

class Label extends React.Component {
  render() {
    return (
      <span className={`label pull-${this.props.align} ${this.props.theme}`}>
        {this.props.icon ? <i className={`fa ${this.props.icon}`} /> : ''}
        {this.props.stat}
      </span>
    );
  }
}

Label.propTypes = {
  theme: PropTypes.string,
  icon: PropTypes.string,
  align: PropTypes.string,
  stat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

Label.defaultProps = {
  theme: 'label-primary',
  align: 'right',
  icon: '',
  stat: ''
};

export default Label;
